Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentEmailSummaryView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_email_summary"]
  className: 'sc-summary'

  initialize: (options = {}) ->
    @fromName = options.email.getValue 'authorname'
    @fromEmail = options.email.getValue 'authorusername'
    @toName = options.email.getValue 'to_name'
    @toEmail = options.email.getValue 'to_email'
    @subject = options.email.getValue 'subject'

  render: ->
    @$el.html @template { @fromName, @fromEmail, @toName, @toEmail, @subject }
    this
